export default __webpack_public_path__ + "static/media/notFound.085d0fe0.png";